var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPh = function SvgPh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 32,
    fill: "none",
    viewBox: "0 0 33 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#FF0851",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M11.842 11.804a19.5 19.5 0 0 0 3.795 5.347 19.5 19.5 0 0 0 5.346 3.795c.166.08.25.12.355.15.374.11.833.031 1.15-.196.088-.063.165-.14.317-.292.466-.466.7-.7.933-.852a2.67 2.67 0 0 1 2.908 0c.234.153.467.386.933.852l.26.26c.709.708 1.063 1.063 1.255 1.443.383.757.383 1.65 0 2.407-.192.38-.546.735-1.255 1.444l-.21.21c-.706.706-1.06 1.06-1.54 1.329-.532.299-1.36.514-1.97.512-.55-.001-.927-.108-1.68-.322a25.4 25.4 0 0 1-11.045-6.498c-3.184-3.184-5.35-7-6.498-11.045-.213-.752-.32-1.128-.322-1.68-.002-.61.214-1.437.513-1.97.27-.48.623-.833 1.329-1.54l.21-.21c.708-.708 1.063-1.062 1.443-1.255a2.67 2.67 0 0 1 2.407 0c.381.193.735.547 1.444 1.256l.26.26c.466.465.699.699.851.933a2.67 2.67 0 0 1 0 2.907c-.152.234-.385.468-.851.934-.153.152-.229.228-.293.317a1.4 1.4 0 0 0-.196 1.15c.03.105.07.188.15.354"
  })));
};
export default SvgPh;